import { Row } from "@tanstack/react-table"
import { ReactNode } from "react"
import { ChevronDownIcon, ChevronRightIcon } from "Components/atoms/icons"

interface TreeNameCellProps<T> {
    row: Row<T>
    children: ReactNode
    // Indentation per level, in px
    indent?: number
}

// Name cell for grouped tables (Division > Department, Branch > ... > Project). The whole name
// (arrow + text) collapses/expands the group; children are indented under their parent.
const TreeNameCell = <T,>({ row, children, indent = 20 }: TreeNameCellProps<T>) => {
    const canExpand = row.getCanExpand()
    return (
        <span
            className={`tree-name-cell ${canExpand ? 'is-group' : ''}`}
            onClick={canExpand ? row.getToggleExpandedHandler() : undefined}
            role={canExpand ? 'button' : undefined}
            title={canExpand ? (row.getIsExpanded() ? 'Collapse' : 'Expand') : undefined}
            style={{ paddingLeft: `${row.depth * indent}px` }}
        >
            {canExpand
                ? (row.getIsExpanded() ? <ChevronDownIcon /> : <ChevronRightIcon />)
                : row.depth > 0 && <span className="tree-name-cell__spacer" />}
            <span className="tree-name-cell__text">{children}</span>
        </span>
    )
}

export default TreeNameCell
